var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.mode === 'join')?_c('join-party',{on:{"changeMode":_vm.changeMode}}):_c('create-party',{on:{"changeMode":_vm.changeMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }